import { ApiCommunications, NullPromise } from '../../webmodule-common/interop/webmodule-interop';
import type { FabricationPurchaseOrderApi } from './fabrication-purchase-order-api';
import type {
  InputAddJobToPurchaseOrder,
  InputAddManualLineToPurchaseOrder,
  InputCancelPurchaseOrder,
  InputCreateEmptyPurchaseOrder,
  InputCreatePurchaseOrderFromJobs,
  InputIssueFabricationPurchaseOrder,
  InputRemovePurchaseOrderLine,
  InputUpdatePurchaseOrderHeader,
  InputUpdatePurchaseOrderLineQuantity,
  JobPurchaseOrderBadgesView,
  PurchaseOrderBadgeView,
  PurchaseOrderSummaryView,
  PurchaseOrderSummaryViewResultPaginated,
  RequestGetFabricationPurchaseOrder,
  RequestGetFabricationPurchaseOrderTotalsByState,
  RequestGetPurchaseOrderSummary,
  RequestGetPurchaseOrdersByIds,
  RequestGetPurchaseOrdersForJob,
  RequestGetPurchaseOrdersForJobs,
  ResultGetFabricationPurchaseOrderTotalsByState,
  ResultPurchaseOrder,
  ResultVoid
} from './dealer-api-interface-all';

export class FabricationPurchaseOrderApiImplementation implements FabricationPurchaseOrderApi {
  api: ApiCommunications;

  constructor(api: ApiCommunications) {
    this.api = api;
  }

  async getPurchaseOrder(request: RequestGetFabricationPurchaseOrder): NullPromise<ResultPurchaseOrder> {
    return await this.api.post<ResultPurchaseOrder>('api/FabricationPurchaseOrder/GetPurchaseOrder', request);
  }

  async getPurchaseOrderSummary(
    request: RequestGetPurchaseOrderSummary
  ): NullPromise<PurchaseOrderSummaryViewResultPaginated> {
    return await this.api.post<PurchaseOrderSummaryViewResultPaginated>(
      'api/FabricationPurchaseOrder/GetPurchaseOrderSummary',
      request
    );
  }

  async getPurchaseOrderTotalsByState(
    request: RequestGetFabricationPurchaseOrderTotalsByState
  ): NullPromise<ResultGetFabricationPurchaseOrderTotalsByState> {
    return await this.api.post<ResultGetFabricationPurchaseOrderTotalsByState>(
      'api/FabricationPurchaseOrder/GetPurchaseOrderTotalsByState',
      request
    );
  }

  async getPurchaseOrdersForJob(request: RequestGetPurchaseOrdersForJob): NullPromise<PurchaseOrderBadgeView[]> {
    return await this.api.post<PurchaseOrderBadgeView[]>(
      'api/FabricationPurchaseOrder/GetPurchaseOrdersForJob',
      request
    );
  }

  async getPurchaseOrdersForJobs(request: RequestGetPurchaseOrdersForJobs): NullPromise<JobPurchaseOrderBadgesView[]> {
    return await this.api.post<JobPurchaseOrderBadgesView[]>(
      'api/FabricationPurchaseOrder/GetPurchaseOrdersForJobs',
      request
    );
  }

  async getPurchaseOrdersByIds(request: RequestGetPurchaseOrdersByIds): NullPromise<PurchaseOrderSummaryView[]> {
    return await this.api.post<PurchaseOrderSummaryView[]>(
      'api/FabricationPurchaseOrder/GetPurchaseOrdersByIds',
      request
    );
  }

  async createPurchaseOrderFromJobs(input: InputCreatePurchaseOrderFromJobs): NullPromise<ResultPurchaseOrder> {
    return await this.api.post<ResultPurchaseOrder>('api/FabricationPurchaseOrder/CreatePurchaseOrderFromJobs', input);
  }

  async createEmptyPurchaseOrder(input: InputCreateEmptyPurchaseOrder): NullPromise<ResultPurchaseOrder> {
    return await this.api.post<ResultPurchaseOrder>('api/FabricationPurchaseOrder/CreateEmptyPurchaseOrder', input);
  }

  async addJobToPurchaseOrder(input: InputAddJobToPurchaseOrder): NullPromise<ResultPurchaseOrder> {
    return await this.api.post<ResultPurchaseOrder>('api/FabricationPurchaseOrder/AddJobToPurchaseOrder', input);
  }

  async updatePurchaseOrderHeader(input: InputUpdatePurchaseOrderHeader): NullPromise<ResultPurchaseOrder> {
    return await this.api.post<ResultPurchaseOrder>('api/FabricationPurchaseOrder/UpdatePurchaseOrderHeader', input);
  }

  async updatePurchaseOrderLineQuantity(input: InputUpdatePurchaseOrderLineQuantity): NullPromise<ResultPurchaseOrder> {
    return await this.api.post<ResultPurchaseOrder>(
      'api/FabricationPurchaseOrder/UpdatePurchaseOrderLineQuantity',
      input
    );
  }

  async removePurchaseOrderLine(input: InputRemovePurchaseOrderLine): NullPromise<ResultPurchaseOrder> {
    return await this.api.post<ResultPurchaseOrder>('api/FabricationPurchaseOrder/RemovePurchaseOrderLine', input);
  }

  async cancelPurchaseOrder(input: InputCancelPurchaseOrder): NullPromise<ResultPurchaseOrder> {
    return await this.api.post<ResultPurchaseOrder>('api/FabricationPurchaseOrder/CancelPurchaseOrder', input);
  }

  async addManualLineToPurchaseOrder(input: InputAddManualLineToPurchaseOrder): NullPromise<ResultPurchaseOrder> {
    return await this.api.post<ResultPurchaseOrder>('api/FabricationPurchaseOrder/AddManualLineToPurchaseOrder', input);
  }

  async issuePurchaseOrder(input: InputIssueFabricationPurchaseOrder): NullPromise<ResultVoid> {
    return await this.api.post<ResultVoid>('api/FabricationPurchaseOrder/IssuePurchaseOrder', input);
  }
}
